import { render, staticRenderFns } from "./WatchListItem.vue?vue&type=template&id=4133ae9f&"
import script from "./WatchListItem.vue?vue&type=script&lang=ts&"
export * from "./WatchListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports